module.exports = __webpack_public_path__ + "static/media/7.dc3c6ca1.jpg";